import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/system-config";

export const pagingSystemConfigs = (searchObject) => {
  var url = API_PATH + "/paging-system-config";
  return axios.post(url, searchObject);
};

export const getSystemConfig = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const createSystemConfig = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editSystemConfig = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deleteSystemConfig = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};

export const checkCode = (dto) => {
  var url = API_PATH + "/check-key-code";
  return axios.post(url, dto);
};

export const getByConfigKey = (key) => {
  let url = API_PATH + "/getByKey/" + key;
  return axios.get(url);
}
